import { mapState } from "vuex";
import featureFlags from "@/mixins/featureFlags";

// Client-side "tax info is fully set up for this tenant" check. Backed by the
// `Client.taxInfoEnabled` master switch on the Client table, which is only ever
// true once all 4 tax config values (data_vault_tenant_id + the 3 WIR/DataVault
// secrets) have been saved via Developer Settings.
//
// `featureFlags` is mixed in here rather than left to the consumer so that
// `canCollectTaxInfo` below always has `isTaxInfoEnabled()` available - the two
// guards are meant to be paired, and pairing them here means a caller cannot
// accidentally check only one.
export default {
  mixins: [featureFlags],
  methods: {
    // Optional clientId parameter; falls back to the caller's home client when
    // omitted, or when the id isn't in the dropdown (non-admins have no dropdown).
    isTaxInfoConfigured(clientId = undefined) {
      if (clientId) {
        const client = (this.clients || []).find((c) => c.clientId === clientId);
        if (client) return !!client.taxInfoEnabled;
      }
      return !!this.userProfile?.Client?.taxInfoEnabled;
    },
  },
  computed: {
    ...mapState(["userProfile", "clients"]),
    // The two guards together: the global `feature-tax-info` kill switch AND
    // this tenant being opted in and fully configured. Both must hold before any
    // tax-info UI is offered, or a participant is shown a form the server will
    // reject.
    //
    // This resolves the caller's own client. A component that needs to ask about
    // a different client (e.g. an admin editing a user elsewhere) should declare
    // its own `canCollectTaxInfo` passing a clientId to `isTaxInfoConfigured` -
    // a component-level computed takes precedence over this one.
    canCollectTaxInfo() {
      return this.isTaxInfoEnabled() && this.isTaxInfoConfigured();
    },
  },
};
